import { Button, Card } from 'antd';
import React from 'react';
import { useDeleteServiceableUrlMutation } from './service';
import ServiceableUrlsTable from './table/ServiceableUrlsTable';
import LoaderCard from '../shared/LoaderCard';
import useFetchServiceableUrlsPage from './hooks/useFetchServiceableUrlsPage';
import useAddUrlAnalysisProcessWithNotification from '../process/hooks/useAddUrlAnalysisProcessWithNotification';
import { useFetchUrlClustersQuery } from '../urlClusters/service';

type Props = {
    websiteGuid: string;
};

export default function ServiceableUrls({ websiteGuid }: Props) {
    const { serviceableUrls, isFetchingServiceableUrlsNextPage, isLoadingServiceableUrlsFirstPage, hasMore, handleLoadMore } = useFetchServiceableUrlsPage({
        websiteGuid,
    });
    const { data: urlClusters, isLoading: isLoadingUrlClusters } = useFetchUrlClustersQuery({ w_guid: websiteGuid });
    const [deleteServiceableUrl, { isLoading: isDeletingUrl }] = useDeleteServiceableUrlMutation();

    const { addUrlAnalysisProcess, isAddingUrlAnalysisProcess } = useAddUrlAnalysisProcessWithNotification();

    const handleCheckUrlClick = (urlGuid: string) => {
        addUrlAnalysisProcess(websiteGuid, urlGuid);
    };

    const handleDeleteUrlClick = (urlGuid: string) => {
        deleteServiceableUrl({ w_guid: websiteGuid, url_guid: urlGuid });
    };
    const isLoading = isLoadingServiceableUrlsFirstPage || isLoadingUrlClusters;

    return (
        <>
            {isLoading && <LoaderCard />}
            {!isLoading && (
                <Card>
                    <ServiceableUrlsTable
                        serviceableUrls={serviceableUrls}
                        urlClusters={urlClusters || []}
                        isCheckButtonLoading={isAddingUrlAnalysisProcess}
                        isDeleteButtonLoading={isDeletingUrl}
                        onCheck={handleCheckUrlClick}
                        onDelete={handleDeleteUrlClick}
                        showClusterLabel
                    />

                    {hasMore && (
                        <Button
                            type="primary"
                            size="small"
                            onClick={handleLoadMore}
                            loading={isFetchingServiceableUrlsNextPage}
                            style={{ marginTop: '24px' }}
                        >
                            Load more
                        </Button>
                    )}
                </Card>
            )}
        </>
    );
}
